// import React , {useEffect} from "react";
// import { Link } from "react-router-dom";
// import { Container, Row, Col } from "react-bootstrap";
// import {
//   FaFacebook,
//   FaInstagram,
//   FaLinkedin,
//   FaYoutube,
//   FaTwitter,
//   FaArrowUp,
// } from "react-icons/fa";
// import { logo, website, websiteName } from "../../config/Config";

// // useEffect (()=> {
// // window.scrollTo(0,0)
// // },[location.pathname])

// const Footer = () => {
//   return (
//     <footer className="footer">
//       <Container>
//         <Row className="footer-top">
//           <Col md={6} lg={5}>
//             <div className="brand">
//               <img src={logo} alt="" className="img-fluid" />
//             </div>
//             <p>
//               Welcome to our trading site! We offer the best, most affordable
//               products and services around. Shop now and start finding great
//               deals!
//             </p>
        
//           </Col>

//           <Col md={3} sm={6} lg={3}>
//             <h5>Quick Links</h5>
//             <ul>
//               <li> <Link to="/about">About Us</Link></li>
//               <li> <Link to="/contact">Contact Us</Link></li>
//               {/* <li> <Link to="/">Teams</Link></li>
//               <li> <Link to="/">Services</Link></li>
//               <li> <Link to="/">Features</Link></li> */}
//             </ul>
//           </Col>

//           {/* <Col md={3} sm={6} lg={2}>
//             <h5>Support</h5>
//             <ul>
//               <li> <Link to="/">Terms & Conditions</Link></li>
//               <li> <Link to="/">Privacy Policy</Link></li>
//               <li> <Link to="/">FAQs</Link></li>
//               <li> <Link to="/">Support Center</Link></li>
//             </ul>
//           </Col> */}


//           <Col lg={4} className="subscribe-section">
//       <h3>Subscribe for latest update</h3>
//       <form className="subscribe-form">
//         <input
//           type="email"
//           placeholder="Email Address"
//           className="form-control email-input"
//         />
//         <button type="submit" className="btn subscribe-btn">
//           Subscribe →
//         </button>
//       </form>
//     </Col>

//         </Row>

//         <Row className="footer-bottom">
//           <Col lg={6}>
//             <p>© 2024 All Rights Reserved By {websiteName}</p>
//           </Col>
//           <Col lg={6} className="social-icons">
//             <FaFacebook />
//             <FaInstagram />
//             <FaLinkedin />
//             <FaYoutube />
//             <FaTwitter />
//           </Col>
          
//         </Row>
//       </Container>
//     </footer>
//   );
// };

// export default Footer;


import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaTwitter,
} from "react-icons/fa";
import { logo, websiteName } from "../../config/Config";

const Footer = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); 
  }, [location.pathname]); 

  return (
    <footer className="footer">
      <Container>
        <Row className="footer-top">
          <Col md={6} lg={5}>
            <div className="brand">
              <img src={logo} alt="" className="img-fluid" />
            </div>
            <p>
              Welcome to our trading site! We offer the best, most affordable
              products and services around. Shop now and start finding great
              deals!
            </p>
          </Col>

          <Col md={3} sm={6} lg={3}>
            <h5>Quick Links</h5>
            <ul>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>
          </Col>

          <Col lg={4} className="subscribe-section">
            <h3>Subscribe for latest update</h3>
            <form className="subscribe-form">
              <input
                type="email"
                placeholder="Email Address"
                className="form-control email-input"
              />
              <button type="submit" className="btn subscribe-btn">
                Subscribe →
              </button>
            </form>
          </Col>
        </Row>

        <Row className="footer-bottom">
          <Col lg={6}>
            <p>© 2024 All Rights Reserved By {websiteName}</p>
          </Col>
          <Col lg={6} className="social-icons">
            <FaFacebook />
            <FaInstagram />
            <FaLinkedin />
            <FaYoutube />
            <FaTwitter />
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
